<div >
    <app-navbar></app-navbar>
</div>
<!-- App notifications (NotifyService): top right, newest on top. -->
<app-notify-stack></app-notify-stack>




